import React from "react";

/**
 * Floating WhatsApp button — sedí VŽDY nad chat launcherem Lenky.
 * Pozice je počítaná z výšky chat tlačítka (h-14 = 56 px) + bezpečný odstup (~12 px).
 *   Chat launcher: bottom-20 (mobil) / bottom-24 (desktop) → 80 / 96 px
 *   WhatsApp FAB: bottom 150 / 170 px → nikdy se nepřekrývá
 * Vyšší z-index než chat zajistí, že ikona nikdy nezmizí pod jiným prvkem.
 */
export default function WhatsAppFab() {
  return (
    <a
      href="https://wa.me/420775659129"
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-fab"
      aria-label="Napsat na WhatsApp STK Komfort Znojmo"
      title="Napsat na WhatsApp STK Komfort Znojmo"
      className="fixed bottom-[150px] sm:bottom-[170px] right-4 sm:right-7 z-[65] flex h-12 w-12 items-center justify-center rounded-full shadow-[0_10px_28px_-4px_rgba(37,211,102,0.6)] hover:scale-110 transition-transform"
      style={{ backgroundColor: "#25D366" }}
    >
      <span className="sr-only">WhatsApp +420 775 659 129</span>
      <svg className="h-6 w-6 text-white" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
        <path d="M12.04 2C6.58 2 2.13 6.45 2.13 11.91c0 2.1.55 4.15 1.6 5.97L2 22l4.25-1.11c1.75.96 3.73 1.47 5.79 1.47h.01c5.46 0 9.91-4.45 9.91-9.91 0-2.65-1.03-5.14-2.9-7.01A9.83 9.83 0 0 0 12.04 2zm0 18.07h-.01a8.18 8.18 0 0 1-4.17-1.14l-.3-.18-3.1.81.83-3.02-.2-.31a8.16 8.16 0 0 1-1.25-4.35c0-4.5 3.67-8.16 8.18-8.16 2.18 0 4.23.85 5.78 2.39a8.13 8.13 0 0 1 2.4 5.78c0 4.51-3.67 8.18-8.16 8.18zm4.49-6.13c-.25-.12-1.46-.72-1.69-.8-.23-.08-.39-.12-.56.12-.16.25-.64.8-.78.96-.14.16-.29.18-.54.06-.25-.12-1.04-.38-1.98-1.22-.73-.65-1.22-1.46-1.37-1.71-.14-.25-.02-.38.11-.5.11-.11.25-.29.37-.43.13-.15.16-.25.25-.41.08-.16.04-.31-.02-.43-.06-.12-.56-1.34-.76-1.84-.2-.49-.4-.42-.55-.43-.14-.01-.31-.01-.47-.01a.9.9 0 0 0-.65.31c-.22.25-.86.84-.86 2.05 0 1.21.88 2.38 1 2.55.12.16 1.74 2.66 4.22 3.73.59.25 1.05.41 1.41.52.59.19 1.13.16 1.55.1.47-.07 1.46-.6 1.66-1.18.21-.58.21-1.07.14-1.18-.06-.12-.22-.18-.47-.31z"/>
      </svg>
    </a>
  );
}
